import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, [
  /*#__PURE__*/_createElementVNode("h4", null, " Tableau de Bord")
], -1)
const _hoisted_4 = { class: "row row-cols-1 row-cols-md-3 row-cols-xxl-5 g-3" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "stat-card card border-0 rounded-3 overflow-hidden" }
const _hoisted_7 = { class: "p-4 d-flex align-items-center gap-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper bg-success rounded-3 d-flex align-items-center justify-content-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-newspaper text-white fs-4" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "stat-label mb-0" }, "Actualités", -1)
const _hoisted_10 = { class: "stat-value mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "stat-card-bar bg-success" }, null, -1)
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "stat-card card border-0 rounded-3 overflow-hidden" }
const _hoisted_14 = { class: "p-4 d-flex align-items-center gap-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper bg-danger rounded-3 d-flex align-items-center justify-content-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera-video text-white fs-4" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "stat-label mb-0" }, "Vidéothèque", -1)
const _hoisted_17 = { class: "stat-value mb-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "stat-card-bar bg-danger" }, null, -1)
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "stat-card card border-0 rounded-3 overflow-hidden" }
const _hoisted_21 = { class: "p-4 d-flex align-items-center gap-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper bg-primary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-images text-white fs-4" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "stat-label mb-0" }, "Photothèque", -1)
const _hoisted_24 = { class: "stat-value mb-0" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "stat-card-bar bg-primary" }, null, -1)
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "stat-card card border-0 rounded-3 overflow-hidden" }
const _hoisted_28 = { class: "p-4 d-flex align-items-center gap-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper bg-dark rounded-3 d-flex align-items-center justify-content-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-gear-fill fs-3",
    style: {"color":"white"}
  })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "stat-label mb-0" }, "Services", -1)
const _hoisted_31 = { class: "stat-value mb-0" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "stat-card-bar bg-dark" }, null, -1)
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "stat-card card border-0 rounded-3 overflow-hidden" }
const _hoisted_35 = { class: "p-4 d-flex align-items-center gap-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper bg-secondary rounded-3 d-flex align-items-center justify-content-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-people-fill fs-3",
    style: {"color":"white"}
  })
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "stat-label mb-0" }, "Partenaires", -1)
const _hoisted_38 = { class: "stat-value mb-0" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "stat-card-bar bg-secondary" }, null, -1)
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "stat-card card border-0 rounded-3 overflow-hidden" }
const _hoisted_42 = { class: "p-4 d-flex align-items-center gap-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper bg-info rounded-3 d-flex align-items-center justify-content-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-diagram-3-fill fs-3",
    style: {"color":"white"}
  })
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "stat-label mb-0" }, "Organisations", -1)
const _hoisted_45 = { class: "stat-value mb-0" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "stat-card-bar bg-info" }, null, -1)
const _hoisted_47 = { class: "col-xxl-4" }
const _hoisted_48 = { class: "col-xxl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhatHappening = _resolveComponent("WhatHappening")!
  const _component_CategoriesCourses = _resolveComponent("CategoriesCourses")!
  const _component_CoursesClass = _resolveComponent("CoursesClass")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WhatHappening),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.statistiques.actualites), 1)
                ])
              ]),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.statistiques.videos), 1)
                ])
              ]),
              _hoisted_18
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.statistiques.photos), 1)
                ])
              ]),
              _hoisted_25
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", null, [
                  _hoisted_30,
                  _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.statistiques.services), 1)
                ])
              ]),
              _hoisted_32
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", null, [
                  _hoisted_37,
                  _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.statistiques.partenaires), 1)
                ])
              ]),
              _hoisted_39
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", null, [
                  _hoisted_44,
                  _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.statistiques.organisations), 1)
                ])
              ]),
              _hoisted_46
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_CategoriesCourses)
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_CoursesClass)
      ])
    ])
  ], 64))
}